import { useState } from "react";

export interface ModalState<TPayload> {
  isOpen: boolean;
  payload: TPayload | null;
  openModal: (data?: TPayload) => void;
  closeModal: () => void;
  statusMessage: string;
  setStatusMessage: (message: string) => void;
  isSubmitting: boolean;
  setIsSubmitting: (flag: boolean) => void;
}

function useModalState<TPayload = undefined>(): ModalState<TPayload> {
  const [isOpen, setIsOpen] = useState(false);
  const [payload, setPayload] = useState<TPayload | null>(null);
  const [statusMessage, setStatusMessageValue] = useState("");
  const [isSubmitting, setIsSubmittingValue] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
    setPayload(null);
    setStatusMessageValue("");
    setIsSubmittingValue(false);
  };

  const openModal = (data?: TPayload) => {
    setPayload(data ?? null);
    setStatusMessageValue("");
    setIsSubmittingValue(false);
    setIsOpen(true);
  };

  const setStatusMessage = (message: string) => setStatusMessageValue(message);
  const setIsSubmitting = (flag: boolean) => setIsSubmittingValue(flag);

  return {
    isOpen,
    payload,
    openModal,
    closeModal,
    statusMessage,
    setStatusMessage,
    isSubmitting,
    setIsSubmitting,
  };
}

export default useModalState;
